<template>
    <div>
        <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :operate="operate" :permission="permission" :searchs="searchs" ref="table"></common-table>

        <!--加减款弹出框-->
        <div class="dialog">
            <el-dialog title="额度加减款" :visible.sync="quotaVisible" custom-class="common-dialog" :close-on-click-modal="false" width="30%">
                <div class="dialog_body">
                    <el-form label-position="right" status-icon label-width=""
                             :model="quotaForm" ref="quotaForm">

                        <el-form-item label="" prop="quota" :rules="[]">
                            <div>
                                <el-input placeholder="当前额度" v-model="quotaForm.quota">
                                    <template slot="prepend">当前额度(分)</template>
                                </el-input>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="limit" :rules="[                                              ]">
                            <div style="margin-top: 15px;">
                                <el-input placeholder="请输入金额(分)" v-model="quotaForm.limit" class="input-with-select">
                                    <el-select style="width: 120px" v-model="quotaForm.type" slot="prepend" placeholder="请选择">
                                        <el-option label="加款" value="1"></el-option>
                                        <el-option label="减款" value="0"></el-option>
                                    </el-select>
                                </el-input>
                            </div>
                        </el-form-item>

                        <el-form-item label="">
                            <el-radio-group v-model="quotaForm.money" size="small">
                                <el-radio-button border label="100000">1000元</el-radio-button>
                                <el-radio-button border label="200000">2000元</el-radio-button>
                                <el-radio-button border label="300000">3000元</el-radio-button>
                                <el-radio-button border label="500000">5000元</el-radio-button>
                                <el-radio-button border label="1000000">10000元</el-radio-button>
                                <el-radio-button border label="2000000">20000元</el-radio-button>
                                <el-radio-button border label="3000000">30000元</el-radio-button>
                            </el-radio-group>
                        </el-form-item>

                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="quotaVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" @click="submitQuotaForm">确 定</el-button>
                </div>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";

    export default {
        name: "Quota",
        components: {CommonTable},
        data(){
            return{
                quotaForm:{
                    limit: 0
                },
                quotaVisible: false,
                searchs:[
                    {
                        name: 'username',
                        placeholder: '用户名',
                        type: 'input'
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'quota:add',
                    update: 'quota:update',
                    delete: 'quota:delete',
                    deleteBatch: 'quota:deleteBatch'
                },
                url: {
                    get: '/quota/listByCondition',
                    add: '/quota/add',
                    //update: '/quota/update',
                    //delete: '/quota/delete/',
                    //delete_batch: '/quota/deleteBatch',
                    status: '/quota/status'
                },
                tableColumns: [
                    {
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                },{
                    field: 'userNick',
                    label: '用户昵称',
                    show: true,
                    width: '',
                }/*,{
                    field: 'orderTypeId',
                    label: '订单分类',
                    selectUrl: '/orderType/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    width: '',
                }*/,{
                    field: 'limit',
                    label: '额度(元)',
                    show: {
                        type: 'money'
                    },
                    width: '',
                },{
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                },{
                    field: 'status',
                    label: '状态',
                    show: true,
                    width: '90',
                    status: true,
                }
                ],
                formFields: {
                    addTitle: '添加用户额度',
                    updateTitle: '修改用户额度',
                    labelWidth: '105px',
                    model: [{
                        field: 'username',
                        label: '用户名：',
                        type: 'input',
                        placeholder: '用户名',
                        rules:[{required: true, message: '请输入用户名', trigger: 'blur'}],
                        add: true,
                        update: false
                    },{
                        field: 'userNick',
                        label: '用户昵称：',
                        type: 'input',
                        placeholder: '用户昵称',
                        rules:[{required: true, message: '请输入用户昵称', trigger: 'blur'}],
                        add: false,
                        onlyShow: true,
                        update: true
                    }/*,{
                        field: 'orderTypeId',
                        label: '订单分类：',
                        type: 'select',
                        selectUrl: "/orderType/getAll",
                        selectData: [],
                        placeholder: '任务类型',
                        rules:[{required: true, message: '请输入任务类型', trigger: 'blur'}],
                        add: true,
                        update: true
                    }*/,{
                        field: 'limit',
                        label: '额度（分）：',
                        type: 'input',
                        placeholder: '额度（分）',
                        rules:[{required: true, message: '请输入额度（分）', trigger: 'blur'}],
                        add: true,
                        update: true,
                    }],
                },
                operate: [{
                    icon: 'el-icon-edit',
                    type: 'text',
                    text: '加减款',
                    handle: (row) => {
                        this.quotaVisible = true;
                        this.quotaForm.quota = row.limit;
                        this.quotaForm.id = row.id;
                        //this.quotaForm.type = 1;
                    }
                }]
            }
        },
        computed:{
            newMoney(){
                return this.quotaForm.money;
            },
            newLimit(){
                return this.quotaForm.limit;
            }
        },
        watch:{
            newMoney(val){
                this.quotaForm.limit = val;
            },
            newLimit(val){
                this.quotaForm.money = val;
            }
        },
        methods:{
            submitQuotaForm(){
                let type = this.quotaForm.type == 1 ? '加款' : '减款';
                //console.log(this.quotaForm);
                this.$axios.post({
                    url: '/quota/addOrSub',
                    data: this.quotaForm,
                    confirm: '确定进行' + type + '操作？',
                    success: (data) => {
                        console.log("quota")
                        console.log(data)
                        if (data.code == 0) {
                            this.$message.success(type + "成功");
                            this.quotaVisible = false;
                            this.$refs.table.getData();
                        }else {
                            this.$message.error(data.msg || type + "失败")
                        }
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .input-with-select {
        background-color: #fff;
    }
</style>
